<div class="notifications-page">
  <div class="notifications-content">
    <div class="notifications-header">
      <mat-icon class="header-icon">notifications</mat-icon>
      <h1>Notifications</h1>
    </div>
    <mat-divider></mat-divider>
    <div class="notification-list-container" (scroll)="onScroll($event)">
      <ng-container *ngFor="let notification of notifications">
        <ddc-notification-content
          [getNotificationIcon]="getNotificationIcon"
          [getNotificationMessage]="getNotificationMessage"
          [notification]="notification"
          [type]="notification.type"
        ></ddc-notification-content>
      </ng-container>
      <div class="loading-spinner" *ngIf="loading">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
      <div class="no-notifications" *ngIf="!loading && notifications.length === 0">
        <mat-icon>notifications_none</mat-icon>
        <span>No notifications found.</span>
      </div>
    </div>
  </div>
</div>
